<template>
  <div class="">
    <div class="">
      <vs-navbar
        class="navbar-custom navbar-skelton"
        :color="navbarColor"
        type="fund"
        text-color="#FFFFFF"
        active-text-color="#FFCC00"
      >
        <div
          tag="div"
          class="vx-logo cursor-pointer mr-auto flex items-center"
          v-if="$route.meta.whiteNavBar !== '1'"
        >
          <img :src="logo" alt="logo" class="logo-img mr-4" v-if="logo" />
          <span class="mr-4" :style="navBarVLogoText">Agent Academy</span>
          <vs-navbar-item
            v-if="activeUserInfo.is_certified == '1'"
            v-for="(item, key) in navMenuItems"
            :key="key"
            :index="key"
          >
            <!-- item.url || '#' -->
            <span
              class="m-2 link-item"
              @click="goTo(item.url || '#')"
              :class="[
                { 'is-active-item': activeLink(item.url) ? true : false },
              ]"
              >{{ item.name }}</span
            >

            <!-- <router-link
              :class="[
                { 'is-active-item': activeLink(item.url) ? true : false },
              ]"
              :to="item.url || '#'"
              >{{ item.name }}</router-link
            > -->
          </vs-navbar-item>
        </div>
        <div
          tag="div"
          class="vx-logo cursor-pointer mr-auto flex items-center"
          v-else
        >
          <img
            :src="appSettings.logo.full_path"
            alt="logo"
            class="logo-img mr-4"
            v-if="appSettings.logo"
          />
          <span class="mr-4" :style="navBarVLogoText">Agent Academy</span>
        </div>

        <vs-navbar-item index="0">
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="profil_dropdown cursor-pointer"
          >
            <span class="text-dark font-bold">{{ user_displayName }}</span
            ><feather-icon
              icon="ChevronDownIcon"
              svgClasses="text-black stroke-current w-4 h-8"
            />
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <li
                  @click="logout()"
                  class="
                    flex
                    py-2
                    px-4
                    cursor-pointer
                    hover:bg-primary hover:text-white
                  "
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Déconnexion</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-navbar-item>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import auth from "../../../helpers/auth";

export default {
  name: "horizontalNavbar",
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true,
    },
    navMenuItems: { type: Array },
    navBarVLogoText: { type: Object },
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    logout() {
      if (localStorage.getItem("accessToken")) {
        auth.logout();
        this.$router.push("/login").catch(() => {});
        localStorage.removeItem("userInfo");
      }
    },
    activeLink(path) {
      return path == this.$route.path ? true : false;
    },
    goTo(path) {
      this.$router.push(path);
    },
  },
  computed: {
    navbarColor() {
      return this.$route.meta.whiteNavBar == "0" ? "#212529" : "#FFFFFF";
    },
    appSettings() {
      return JSON.parse(localStorage.getItem("settings"));
    },
    activeUserInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    user_displayName() {
      return this.activeUserInfo.firstname + " " + this.activeUserInfo.lastname;
    },
  },
};
</script>

<style lang="scss">
.link-item {
  font-size: 12px;
  line-height: 19px;
}
.is-active-item {
  font-size: 14px;
  color: #ffcc00 !important;
  font-weight: bold;
}

.profil_dropdown {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 25px;
  gap: 10px;
  height: 34px;
  background: #ffffff;
  border-radius: 50px;
  span {
    font-size: 14px;
    line-height: 16px;
  }
  box-shadow: 7px 7px 10px -2px rgba(0, 0, 0, 0.3);
}

.logo-img {
  width: 4.5rem !important;
}
</style>